angular.module('ui.shell')
    .directive('headerPanelView', function (customTemplateResolver) {
        return {
            restrict: 'E',
            replace: 'true',
            templateUrl: 'app/ui/shell/views/headerPanel.html', // customTemplateResolver.get('headerPanel.html', 'app/ui/shell/views/headerPanel.html'),
            controller: function ($scope, $state, usersRepository) {
                $scope.currentUser = null;
                usersRepository.getCurrentUser()
                    .then(function (user) {
                        $scope.currentUser = user;
                    });
            }
        };
    });